import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";
import { isJson } from "utils/isJson";

export const getAllLeadAsync = createAsyncThunk(
  "master/getAllLeadAsync",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/lead/list-lead?page=${payload?.page || 1}&limit=${payload?.limit || 10}&status=${payload.status || ""}&search=${payload?.search || ""}&businessId=${payload.customer || ""}&site=${payload.site || ""}&lob=${payload.lob || ""}&createdBy=${payload.createdBy || ""}`,
      [],
      toolkit
    );
  }
);
// lead.async.js

export const getSuggestionAsync = createAsyncThunk(
  "master/getSuggestionAsync",
  async (payload, toolkit) => {
    // payload = { search, site }
    let url = `/lead/list-lead?search=${payload.search || ""}&createLead=true`;
    if (payload.site) {
      url += `&site=${payload.site}`;
    }
    return await AxiosClient("GET", url, [], toolkit);
  }
);

export const canApproveAsync = createAsyncThunk(
  "lead/canApproveAsync",
  async (_, toolkit) => {
    return await AxiosClient("GET", `/lead/can-approve`, [], toolkit);
  }
);
// get chamical

export const getChemicalDropdownAsync = createAsyncThunk(
  "master/getAlllead",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/contract/list-chemical-dropdown/${payload?.serviceid}`,
      [],
      toolkit
    );
  }
);

//  get all Laed without pagination
export const getLeadWithoutPaginationAsync = createAsyncThunk(
  "contract/getAlllead",
  async (payload = {}, toolkit) => {
    let url = `/contract/list-lead-dropdown`;
    if (payload && Object.keys(payload).length) {
      const queryString = Object.entries(payload)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
      url += `?${queryString}`;
    }
    return await AxiosClient("GET", url, [], toolkit);
  }
);

// Qutation Dropdown

export const getQuotationDropdownAsync = createAsyncThunk(
  "contract/getQuotationDropdown",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/contract/list-quotation-dropdown/${payload?.leadid}`,
      [],
      toolkit
    );
  }
);

// service dropdown
export const getServiceDropdownAsync = createAsyncThunk(
  "contract/getServiceDropdown",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/contract/list-services-dropdown/${payload?.quotationid}`,
      [],
      toolkit
    );
  }
);

export const createLeadAsync = createAsyncThunk(
  "master/createLeadAsync",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/lead/create-lead`, payload, toolkit);
  }
);

export const updateLeadAsync = createAsyncThunk(
  "admin/updateLeadAsync",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/lead/update-lead/${payload.id}`,
      payload,
      toolkit
    );
  }
);

export const getLeadByIdAsync = createAsyncThunk(
  "master/getLeadByIdAsync",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/lead/get-lead/${payload}`, [], toolkit);
  }
);

export const deleteLeadAsync = createAsyncThunk(
  "master/deleteLeadAsync",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/lead/delete-lead/${payload}`,
      [],
      toolkit
    );
  }
);

// Update lead status

export const updateLeadStatusAsync = createAsyncThunk(
  "admin/updateLeadStatus",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/lead/update-lead-status/${payload.id}`,
      payload,
      toolkit
    );
  }
);

export const approveLeadAsync = createAsyncThunk(
  "admin/approveLead",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/lead/approve-lead/${payload.id}`,
      {},
      toolkit
    );
  }
);

//download Lead Csv File
export const leadExcelDownloadAsync = ({ search, customer, customerName, site, lob, status, createdBy }) => {
  window.open(
    `${process.env.REACT_APP_BASE_URL}/lead/lead-export-to-csv?token=${isJson(localStorage.getItem("auth"))
      ? JSON.parse(localStorage.getItem("auth"))?.token
      : null
    }&search=${search || ""}&businessName=${customerName || ""}&businessId=${customer || ""}&site=${site || ""
    }&lob=${lob || ""}&status=${status || ""}&createdBy=${createdBy || ""}`,
    "_blank"
  );
};

// filter leads  lead/check-parameters?gst

export const getLeadCheckParametersAsync = createAsyncThunk(
  "lead/getLeadCheckParameters",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/lead/check-parameters/${payload?.leadid}`,
      [],
      toolkit
    );
  }
);

export const getGstVerifiedApiAsync = createAsyncThunk(
  "lead/getLeadCheckParameters",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/gst/verify-gst-number/${payload?.gstNumber}`,
      [],
      toolkit
    );
  }
);

export const getLeadListBusinessNameAsync = createAsyncThunk(
  "contract/getLeadListBusinessName",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/lead/list-business-name`, [], toolkit);
  }
);
// Make a lead a master
export const makeLeadMasterAsync = createAsyncThunk(
  "lead/makeLeadMaster",
  async (id, toolkit) => {
    return await AxiosClient("PUT", `/lead/${id}/make-master`, {}, toolkit);
  }
);

// Set a master for a child lead
export const setLeadMasterAsync = createAsyncThunk(
  "lead/setLeadMaster",
  async ({ id, masterId }, toolkit) => {
    return await AxiosClient("PUT", `/lead/${id}/set-master/${masterId}`, {}, toolkit);
  }
);
export const getMasterLeadsDropdownAsync = createAsyncThunk(
  "lead/getMasterLeadsDropdown",
  async (_, toolkit) => {
    return await AxiosClient("GET", `/lead/list-master-leads-dropdown`, [], toolkit);
  }
);
// Get master info (current lead's master and children)
export const getLeadMasterInfoAsync = createAsyncThunk(
  "lead/getLeadMasterInfo",
  async (id, toolkit) => {
    return await AxiosClient("GET", `/lead/${id}/master-info`, [], toolkit);
  }
);